export const CONSTANTS = {
  ROUTES: {
    HOME: '',
    DISPLAY_SETTINGS: 'display-settings',
    SETTING_PAGE: 'settings',
    QR_SCANNER: 'qr-scanner',
    EMP_DETAILS: 'emp-details',
    EMP_HIERARCHY: 'emp-hierarchy',
    NEWS: 'news',
    NEXT_MEETING_DETAILS: 'meeting-details',
    ACCESS_BRIDGE: 'access-bridge',
    NOTIFICATION_SETTINGS: 'notification-settings',
    NOTIFICATIONS_PAGE: 'notifications',
    JOBS_PAGE: 'career',
    CLIC_GAME: 'game',
    JOBS_FILTER: 'filter',
    JOBS_ADD_SKILL: 'add-skill',
    JOB_PAGE: 'details',
    JOB_APPLY: 'apply',
    JOB_STATUS_AND_TRACKER: 'status-and-tracker',
    JOB_ABOUT: 'about',
    REFER_JOB_TO_FRIEND: 'refer-job-to-friend',
    SHARE_JOB_WITH_FRIEND: 'share-with-friend',
    SAVED_JOBS: 'saved',
    FAQ: 'faq',
    PARKING: 'parking',
    IT_ACCESSORY: 'it-accessory',
    CALENDAR: 'holiday-calendar',
    MY_PROFILE: 'profile',
    MY_APPROVAL: 'my-approval',
    MY_APPROVAL_LIST: 'my-approval-list',
    MY_APPROVAL_ITEM_DETAILS: 'my-approval-item-details',
    MY_APPROVAL_FULL_DETAILS: 'full-details',
    GUEST_RESERVATION: 'guest-reservation',
    CAR_WASH: 'car-wash',
    CAR_SERVICES: 'car-services',
    PREVIEW_RESERVATION: 'preview-reservation',
    SYSTEM_PASSWORD_RECOVERY: 'laptop-recovery',
    LAPTOP_RECOVERY_WITHOUT_USB: 'laptop-recovery-without-usb',
    NEW_EMPLOYEE_LAPTOP: 'laptop-new-employee',
    NEW_EMPLOYEE_LAPTOP_MAC: 'new-employee-laptop-mac',
    SYSTEM_PASSWORD_RECOVERY_MAC: 'laptop-recovery-mac',
    SYSTEM_PASSWORD_RECOVERY_MAC_Boot: 'laptop-recovery-mac-boot',
    SYSTEM_PARTITION_RECOVERY: 'laptop-partiton-recovery',
    Sderot_Cafeteria: 'sderot-cafeteria',
    PING: 'ping',
    CAR_PER_DAY: 'car-per-day',
    CAR_PER_DAY_Step2: 'car-per-day-step2',
    CAR_PER_DAY_Step3: 'car-per-day-step3',
    CAR_PER_DAY_Step4: 'car-per-day-step4',
    CAR_ACCIDENT: 'car-accident',
    CAR_ACCIDENT_STEP2: 'car-accident-step2',
    CAR_ACCIDENT_STEP3: 'car-accident-step3',
    CAR_ACCIDENT_STEP4: 'car-accident-step4',
    CAR_ACCIDENT_STEP5: 'car-accident-step5',
    CAR_ACCIDENT_STEP6: 'car-accident-step6',
    MY_CAR_REQUEST: 'my-request',
    TICKET_DETAILS: 'ticket-details',
    SCHEDULE_SERVICE: 'schedule-service',
    VEHICLE_FAULT: 'vehicle-fault',
  },
  PARAMS: {
    USER_ID: 'user_id',
    USER_DISPLAY_NAME: 'user_display_name',
    USER_JOB_TITLE: 'user_job_title',
    MEETING_ID: 'meeting_id',
    JOB_ID: 'job_id',
    JOB_NAME: 'job_name',
    NOTIFICATIONS: 'notifications',
  },
  EMPLOYMENT_SEARCH: {
    MIN_CHARS_FOR_SEARCH: 2,
    SEARCH_RESULTS: 20,
  },
  TIME_ZONE: {
    AGENT_TYPE: 'Mobile',
    SCREEN_ID: 'D',
    FROM_WEEK: 0,
    TO_WEEK: 0,
    GET_EMP_DETAILS: 'Y',
    WEEK_STATE: 'O',
    WEEK_APPROVED: 'N',
    ABSENCE_HOURS: 0,
    WORK_TYPE: 0,
    TOP: false,
  },
  STORAGE_KEYS: {
    NEWS: 'news',
    SKYPE: 'isSkypeInstalled',
  },
  EVENTS: {
    CLOSE_NEWS: 'event-close-news',
    TOGGLE_FULL_PAGE_LOADER: 'toggle-full-page-loader',
    NOTIFY_USER_ALERT: 'notify-user-alert',
    HOMEPAGE_RELOAD_DATA: 'homepage-reload-data',
    SHOW_NEW_VERSION_ALERT: 'show-new-version-alert',
    SHOW_ON_BOARDING: 'show-on-boarding',
    OPEN_CHAT_HISTORY: 'open-chat-history',
  },
  DOCUMENT_VISIBILITY_STATE_VISIBLE: 'visible',
  EXTERNAL_URL: {
    PLAY_MARKET_SKYPE:
      'https://play.google.com/store/apps/details?id=com.microsoft.office.lync15',
    APP_MARKET_SKYPE:
      'https://apps.apple.com/us/app/skype-for-business/id605841731',
    LEARNING_PORTAL: 'https://learning-dev.misnp.amdocs.com',
  },
  TYPES: {
    IT_ACCESSORY: 'it_accessory',
    CALENDAR: 'holiday_calendar',
    GUEST_RESERVATION: 'guest_reservation',
    PREVIEW_RESERVATION: 'preview_reservation',
    MY_APPROVAL: 'my_approval',
    Sderot_Cafeteria: 'sderot_cafeteria',
    REPORTING_HOURS: 'timezone',
    CAR_SERVICES: 'car_services',
  },
  CALENDAR: {
    MAX_COUNTRIES_SELECT: 3,
  },
  HOME: {
    MY_REQUEST_URL: 'https://amdocsuat.service-now.com/ta?id=ta_my_requests',
  },
};
